import { render, staticRenderFns } from "./CourierNameOverrideForm.vue?vue&type=template&id=7eccfecf&scoped=true&"
import script from "./CourierNameOverrideForm.vue?vue&type=script&lang=js&"
export * from "./CourierNameOverrideForm.vue?vue&type=script&lang=js&"
import style0 from "./CourierNameOverrideForm.vue?vue&type=style&index=0&id=7eccfecf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7eccfecf",
  null
  
)

export default component.exports